import React from "react";
import { View, StyleSheet, Platform } from "react-native";
import { CheckBox } from "@rneui/base";
import variables from "src/common/assets/variables";
import { DATE_FORMAT, READABLE_DATE_FORMAT } from "libs/utils/constants";
import moment from "moment";
import translate from "../libs/locale";

const DeliveryTimeOptions = ({
  types,
  selectedDeliveryDate,
  timeSlots,
  selectedDeliveryTime,
  selectedDelivery,
  onClick,
}) => {
  const getCheckedIcon = () => {
    if (Platform.OS === "web") {
      return (
        <View style={[styles.checked, styles.baseCheck]}>
          <View style={styles.innerChecked} />
        </View>
      );
    }
    return "dot-circle-o";
  };

  const getUnCheckedIcon = () => {
    if (Platform.OS === "web") {
      return <View style={[styles.unChecked, styles.baseCheck]} />;
    }
    return "circle-o";
  };

  return (
    <View>
      {types?.map((it) => {
        const dateTime =
          it?.name.includes("SCHEDULED") &&
          selectedDeliveryDate &&
          `${moment(selectedDeliveryDate, DATE_FORMAT).format(
            READABLE_DATE_FORMAT
          )} | ${
            timeSlots.filter((it) => it.id === selectedDeliveryTime)[0]?.name ||
            ""
          }`;
        let name;
        switch (it.name.trim()) {
          case "IN-STORE":
            name = translate("pickupFromStore");
            break;
          case "INSTANT":
            name = translate("instant");
            break;
          case "SCHEDULED":
            name = `${translate("deliverHome")} ${
              dateTime
                ? `(${translate("scheduled")}: ${dateTime})`
                : `(${translate("scheduled")})`
            }`;
        }
        return (
          <CheckBox
            key={it?.id?.toString()}
            checked={selectedDelivery?.id === it?.id}
            onPress={() => onClick(it)}
            checkedIcon={getCheckedIcon()}
            uncheckedIcon={getUnCheckedIcon()}
            title={name}
            checkedColor={variables.$brandColor}
            containerStyle={styles.checkbox}
            titleProps={{
              style: [
                styles.text,
                {
                  color:
                    selectedDelivery?.id === it?.id
                      ? variables.$brandColor
                      : variables.$black,
                  fontFamily:
                    selectedDelivery?.id === it?.id
                      ? "MontserratBold"
                      : "Montserrat",
                },
              ],
            }}
          />
        );
      })}
    </View>
  );
};

export default DeliveryTimeOptions;

const styles = StyleSheet.create({
  checkbox: {
    marginLeft: 0,
    paddingLeft: 0,
  },
  text: {
    fontFamily: "Montserrat",
    fontSize: 14,
  },
  checked: {},
  unChecked: {},
  baseCheck: {
    height: 24,
    width: 24,
    borderRadius: 24,
    marginRight: 12,
    borderColor: variables.$brandColor,
    borderWidth: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  innerChecked: {
    height: 14,
    width: 14,
    borderRadius: 8,
    backgroundColor: variables.$brandColor,
  },
});
